<template>
    <div v-if="showSwitch" class="currency-switch">
        <button
            @click.stop.prevent="switchCurrency"
            class="button blue btn-sm"
            id="currency_switch"
        >
            {{ switchLabel }}
        </button>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
    name: "CurrencySwitch",
    computed: {
        ...mapGetters(["getCurrency", "getBookingDetails"]),
        showSwitch() {
            // Only on the accommodation page; never on the Agape route (forced EUR, PriceTypeID 9)
            return this.$route.name == "Home" && pdID != 9;
        },
        switchLabel() {
            return this.getCurrency.currency == "EUR"
                ? this.$t("Switch to pounds sterling (£)")
                : this.$t("Switch to euros (€)");
        },
        hasCurrencyChoices() {
            const bd = this.getBookingDetails;
            const hasDiscounts = Object.values(bd.discounts).some(
                v => v !== "" && v !== null
            );
            return (
                bd.hire_items.length > 0 ||
                bd.hire_items_price != 0 ||
                bd.ferries.ferry_option != null ||
                bd.transport_discount != 0 ||
                hasDiscounts
            );
        }
    },
    methods: {
        switchCurrency() {
            const other = this.getCurrency.currency == "EUR" ? "GBP" : "EUR";
            if (this.hasCurrencyChoices) {
                this.$swal({
                    title: "",
                    text: this.$t(
                        "Switching currency will clear your extras, travel, insurance and discount choices, and you will need to make them again. Do you want to continue?"
                    ),
                    showCancelButton: true,
                    confirmButtonText: this.$t("Yes, switch currency"),
                    confirmButtonColor: "#00b8d3",
                    cancelButtonText: this.$t("No, keep my choices"),
                    cancelButtonColor: "#00b8d3"
                }).then(result => {
                    if (result.isConfirmed) {
                        this.$store.commit("RESET_CURRENCY_CHOICES");
                        this.$store.commit("CHANGE_PROGRESS_STEP", 1);
                        this.applySwitch(other);
                    }
                });
            } else {
                this.applySwitch(other);
            }
        },
        applySwitch(other) {
            this.$store.commit("UPDATE_CURRENCY", other);
            this.$store.commit("SWAP_ACCOMMODATION_PRICE");
            this.$store.commit("SWAP_AVAILABILITY_PRICES");
        }
    }
};
</script>

<style scoped>
.currency-switch {
    margin-top: 10px;
    text-align: center;
}
</style>
